import createReducer from './../lib/createReducer';
import * as types from './../actions/types';

export const greeting = createReducer({}, {
  [types.GET_GREETING_SUCCESS](state, action) {
    const newState = Object.assign({}, state, {
      audio: action.greeting,
    });

    return newState;
  },
  [types.GET_GREETING_FAIL](state) {
    const newState = Object.assign({}, state, {
      audio: null,
    });

    return newState;
  },
  [types.SET_GREETING_SUCCESS](state, action) {
    const newState = Object.assign({}, state, {
      audio: action.greeting,
    });

    return newState;
  },
  [types.SET_GREETING_FAIL](state) {
    const newState = Object.assign({}, state, {
      audio: null,
    });

    return newState;
  },
  [types.RESET_GREETING_START](state) {
    const newState = Object.assign({}, state, {
      isResetSuccess: false,
    });

    return newState;
  },
  [types.RESET_GREETING_SUCCESS](state) {
    const newState = Object.assign({}, state, {
      isResetSuccess: true,
    });

    return newState;
  },
  [types.RESET_GREETING_FAIL](state) {
    const newState = Object.assign({}, state, {
      isResetSuccess: false,
    });

    return newState;
  },
});

export { greeting as default };
